import { FileDetails } from 'common/models';

export const isAllowedFileType = (file: FileDetails, fileTypeRegex: RegExp) => {
    const extension = file.name.slice(file.name.lastIndexOf('.'));
    return fileTypeRegex.test(extension);
};

export const saveAsFile = (fileBlob?: Blob, fileName?: string): void => {
    if (fileBlob && fileName) {
        const csvURL = window.URL.createObjectURL(fileBlob);
        const anchorElement = document.createElement('a');
        anchorElement.href = csvURL;
        anchorElement.setAttribute('download', fileName);
        anchorElement.click();
        anchorElement.remove();
    }
};

export const formatDatetime = (dateValue: string) => {
    return `${new Date(dateValue)
        .toLocaleDateString('en-GB', { dateStyle: 'medium' })
        .replaceAll(' ', '-')}, ${new Date(dateValue)
        .toLocaleTimeString('en-GB', {
            timeStyle: 'short',
            hourCycle: 'h12'
        })
        .toUpperCase()} (UTC)`;
};

export const fileToBase64 = (filename: string, filepath = '') => {
    return new Promise((resolve) => {
        const file = new File([filename], filepath);
        const reader = new FileReader();
        reader.onload = function (event: any) {
            resolve(event.target?.result.replace('data:', '').replace(/^.+,/, ''));
        };
        reader.readAsDataURL(file);
    });
};

export const formatFileName = (fileName: string) => {
    const nameSplitByExt = fileName.split('.')[0];
    // nameSplitByExt.splice(nameSplitByExt.length - 1, 1);

    // const nameSplitById = nameSplitByExt.join('.').split('_');
    const nameSplitById = nameSplitByExt.split('_');
    nameSplitById.splice(nameSplitById.length - 1, 1);
    return nameSplitById.join('_') + '.' + fileName.split('.')[1];
};
